import React, { ReactElement } from 'react';
import { Text, Box, VStack } from '@chakra-ui/react';
import { MultipleChoiceBlockProps } from '../MultipleChoiceBlock';
import { MCOption } from '../teacher/TeacherMCBlock';
import { MCSubmittedOption } from '../MCSubmittedOption';

type Props = MultipleChoiceBlockProps;

export const ReviewMCBlock = ({ block }: Props): ReactElement => {
  const options = JSON.parse(block.props.options) as MCOption[];

  return (
    <VStack
      border="default"
      borderColor="border.accent"
      borderRadius="l"
      py="l"
      gap="l"
      width="100%"
      alignItems="flex-start"
      contentEditable={false}
      bg="grey.white"
    >
      <Box px="l" width="100%">
        <Text textStyle="h4.medium" color="text.primary" whiteSpace="pre-line">
          {block.props.question}
        </Text>
      </Box>

      <VStack gap="0" width="100%">
        {options.map((opt, i) => (
          <MCSubmittedOption
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            opt={opt}
            i={i}
          />
        ))}
      </VStack>
    </VStack>
  );
};
